import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "pages/LandingPage";
import DetailsPage from "pages/DetailsPage";
import Login from "pages/Login";
import Profile from "pages/Profile";
import { GoogleOAuthProvider } from "@react-oauth/google";
import DashboardSeller from "pages/DashboardSeller";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            <GoogleOAuthProvider
              clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            >
              <Login />
            </GoogleOAuthProvider>
          }
        />
        <Route path="/profile" element={<Profile />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/product/:id" element={<DetailsPage />} />

        <Route path="/seller" element={<DashboardSeller />} />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
}
